import React from 'react'
import { connect } from 'react-redux'
import { logOut } from '../../auth'

import { setUsersList, setConsentsList } from '../../actions/layout'

import merkantilbyggLogo from '../../assets/merkantilbygg-logo.jpg'

const checkIfActive = (route, key) => {
  if (route === key) {
    return 'nav-item active'
  } else {
    return 'nav-item'
  }
}

const HeaderComponent = ({dispatch, layout}) => (
  <header className="site-header mb-4">
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="navbar-brand">
        <a href="/">
          <img src={merkantilbyggLogo} width="140px" />
        </a>
      </div>
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample07" aria-controls="navbarsExample07" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarsExample07">
        <ul className="navbar-nav mr-auto">
          <li className={checkIfActive(layout.route, 'CONSENTS_LIST')}>
            <a className="nav-link" href="" onClick={(e) => { 
              e.preventDefault()
              dispatch(setConsentsList())
            }}>Consents</a>
          </li>
          <li className={checkIfActive(layout.route, 'USERS_LIST')}>
            <a className="nav-link" href="" onClick={(e) => { 
              e.preventDefault()
              dispatch(setUsersList())
            }}>Users</a>
          </li>
        </ul>

        <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" href="" onClick={(e) => { 
                e.preventDefault()
                logOut(dispatch) 
              }}>Sign out</a>
            </li>
          </ul>
      </div>
    </nav>
  </header>
)

const mapStateToProps = state => {
  return {
    layout: state.layout
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch,
  }
}

const Header = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderComponent);

export default Header


// WEBPACK FOOTER //
// ./src/components/header/index.js